export const createCacheForPrice = ({
  season,
  number,
  ean,
  priceGroup,
  priceType,
}) => season + number + ean + priceGroup + priceType;
